import type { TabsProps } from 'antd';
import { Tabs } from 'antd';
import React from 'react';
import FITSBill_Compare from './FITSBill_Compare';
import FITSBill_List from './FITSBill_List';

const items: TabsProps['items'] = [
  {
    key: '1',
    label: 'BSP  Importing',
    children: (
      <>
        <FITSBill_List />
      </>
    ),
  },
  {
    key: '2',
    label: 'BSP Bill Reconciliation',
    children: (
      <>
        <FITSBill_Compare />
      </>
    ),
  },
];

const FITSReportTab: React.FC = () => <Tabs defaultActiveKey='1' items={items} />;

export default FITSReportTab;
